import React from "react";
import { Link } from "react-router-dom";
import "./PrivacyPolicy.css";

const TermsAndConditions = () => {
  return (
    <div className="pp-page">
      <div className="pp-wrapper">
        {/* Header */}
        <div className="pp-header-section">
          <h1 className="pp-main-title">Terms & Conditions</h1>
        </div>

        {/* Introduction */}
        <section className="pp-content-section">
          <p className="pp-intro-text">
            Welcome to Kitty n Mice. By accessing our website or placing an
            order with us, you agree to the following terms and conditions.
            Please read them carefully before making a purchase.
          </p>
        </section>

        {/* General */}
        <section className="pp-content-section">
          <h2 className="pp-section-title">1. General</h2>
          <ul className="pp-list">
            <li className="pp-list-item">
              Kitty n Mice reserves the right to update or modify these terms at
              any time without prior notice.
            </li>
            <li className="pp-list-item">
              Continued use of our website or services implies acceptance of any
              changes made.
            </li>
          </ul>
        </section>

        {/* Products & Availability */}
        <section className="pp-content-section">
          <h2 className="pp-section-title">2. Products & Availability</h2>
          <ul className="pp-list">
            <li className="pp-list-item">
              All products are subject to availability.
            </li>
            <li className="pp-list-item">
              We make every effort to display product colours and details
              accurately, however slight variations may occur due to screen
              settings or photography.
            </li>
          </ul>
        </section>

        {/* Pricing & Payments */}
        <section className="pp-content-section">
          <h2 className="pp-section-title">3. Pricing & Payments</h2>
          <ul className="pp-list">
            <li className="pp-list-item">
              All prices listed are in INR and are inclusive of applicable taxes
              unless stated otherwise.
            </li>
            <li className="pp-list-item">
              Prices may change without prior notice.
            </li>
            <li className="pp-list-item">
              Payments must be completed at the time of order placement through
              our available payment methods.
            </li>
          </ul>
        </section>

        {/* Order Confirmation & Cancellation */}
        <section className="pp-content-section">
          <h2 className="pp-section-title">
            4. Order Confirmation & Cancellation
          </h2>
          <ul className="pp-list">
            <li className="pp-list-item">
              Once an order is placed, you will receive an order confirmation.
            </li>
            <li className="pp-list-item">
              Orders can only be cancelled before dispatch. Once shipped,
              cancellations are not possible.
            </li>
          </ul>
        </section>

        {/* Shipping */}
        <section className="pp-content-section">
          <h2 className="pp-section-title">5. Shipping</h2>
          <ul className="pp-list">
            <li className="pp-list-item">
              Orders are shipped as per our{" "}
              <Link to="/shipping-policy" className="pp-link">
                Shipping Policy
              </Link>
              .
            </li>
            <li className="pp-list-item">
              Delivery timelines are estimated and may vary due to external
              factors beyond our control.
            </li>
          </ul>
        </section>

        {/* Returns & Refunds */}
        <section className="pp-content-section">
          <h2 className="pp-section-title">6. Returns & Refunds</h2>
          <ul className="pp-list">
            <li className="pp-list-item">
              Returns and refunds are governed by our{" "}
              <Link to="/refund-policy" className="pp-link">
                Return Policy
              </Link>
              .
            </li>
            <li className="pp-list-item">
              Kitty n Mice reserves the right to reject returns that do not meet
              the eligibility criteria.
            </li>
          </ul>
        </section>

        {/* Intellectual Property */}
        <section className="pp-content-section">
          <h2 className="pp-section-title">7. Intellectual Property</h2>
          <p className="pp-text">
            All content on this website, including logos, designs, images, text,
            and graphics, is the property of Kitty n Mice and may not be used,
            copied, or reproduced without written permission.
          </p>
        </section>

        {/* User Responsibilities */}
        <section className="pp-content-section">
          <h2 className="pp-section-title">8. User Responsibilities</h2>
          <ul className="pp-list">
            <li className="pp-list-item">
              Customers are responsible for providing accurate personal and
              shipping information.
            </li>
            <li className="pp-list-item">
              Kitty n Mice is not liable for delays or losses caused by
              incorrect details shared by the customer.
            </li>
          </ul>
        </section>

        {/* Limitation of Liability */}
        <section className="pp-content-section">
          <h2 className="pp-section-title">9. Limitation of Liability</h2>
          <p className="pp-text">
            Kitty n Mice shall not be liable for any indirect, incidental, or
            consequential damages arising from the use of our products or
            services.
          </p>
        </section>

        {/* Governing Law */}
        <section className="pp-content-section">
          <h2 className="pp-section-title">10. Governing Law</h2>
          <ul className="pp-list">
            <li className="pp-list-item">
              These terms and conditions are governed by the laws of India.
            </li>
            <li className="pp-list-item">
              Any disputes shall be subject to the jurisdiction of the courts in
              India.
            </li>
          </ul>
        </section>

        {/* Contact */}
        <section className="pp-content-section pp-contact-box">
          <h2 className="pp-section-title">11. Contact Us</h2>
          <p className="pp-text">
            For any questions regarding these terms, please contact us:
          </p>
          <div className="pp-contact-grid">
            <div className="pp-contact-card">
              <strong className="pp-contact-label">Email:</strong>
              <a href="mailto:kittynmice00@gmail.com" className="pp-link">
                kittynmice00@gmail.com
              </a>
            </div>
            <div className="pp-contact-card">
              <strong className="pp-contact-label">Phone:</strong>
              <a href="tel:+918076217714" className="pp-link">
                +91 80762 17714
              </a>
            </div>
          </div>
        </section>

        {/* Footer Links */}
        <div className="pp-footer-section">
          <p className="pp-footer-text">Related Policies:</p>
          <div className="pp-footer-links">
            <Link to="/privacy" className="pp-footer-link">
              Privacy Policy
            </Link>
            <Link to="/shipping-policy" className="pp-footer-link">
              Shipping Policy
            </Link>
            <Link to="/refund-policy" className="pp-footer-link">
              Return Policy
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
